/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Goal_ReturnInputs */

const en_us2_onboarding_goal_return = /** @type {(inputs: Onboarding_Goal_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to training`)
};

const pt_br2_onboarding_goal_return = /** @type {(inputs: Onboarding_Goal_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar a treinar`)
};

const es_419_onboarding_goal_return = /** @type {(inputs: Onboarding_Goal_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a entrenar`)
};

const pt_pt2_onboarding_goal_return = /** @type {(inputs: Onboarding_Goal_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar a treinar`)
};

const fr_fr2_onboarding_goal_return = /** @type {(inputs: Onboarding_Goal_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprendre l'entraînement`)
};

const de_de2_onboarding_goal_return = /** @type {(inputs: Onboarding_Goal_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wieder ins Training einsteigen`)
};

const it_it2_onboarding_goal_return = /** @type {(inputs: Onboarding_Goal_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tornare ad allenarmi`)
};

/**
* | output |
* | --- |
* | "Return to training" |
*
* @param {Onboarding_Goal_ReturnInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_goal_return = /** @type {((inputs?: Onboarding_Goal_ReturnInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Goal_ReturnInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_goal_return(inputs)
	if (locale === "es-419") return es_419_onboarding_goal_return(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_goal_return(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_goal_return(inputs)
	if (locale === "de-DE") return de_de2_onboarding_goal_return(inputs)
	if (locale === "it-IT") return it_it2_onboarding_goal_return(inputs)
	return en_us2_onboarding_goal_return(inputs)
});
export { onboarding_goal_return as "onboarding.goal.return" }